// @flow
import React, { Component } from 'react';
import classnames from 'classnames';
import './LatLongParamContainer.scss';

type Props = {
  disableInput: boolean,
  latlongParams: String,
  showCohortLocationModal: Function,
  handlePickupLatLongChange: Function,
  providerType: number,
}

export class LatLongParamContainer extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      LatLong: props.latlongParams,
    };
  }

  componentWillUpdate(nextProps: Props) {
    if (this.props.latlongParams !== nextProps.latlongParams) {
      this.setState({
        LatLong: nextProps.latlongParams,
      });
    }
  }

  render() {
    if (this.props.providerType === '1') {
      return (
        <div className="field columns">
          <div className="label column is-half" htmlFor="pickup_location">
            Pickup Location
          </div>
          <div className="field column is-half locationParam">
            <input
              name="pickup_latitude"
              type="text"
              className="input column is-three-quarters"
              onChange={this.props.handlePickupLatLongChange}
              disabled={this.props.disableInput}
              value={this.state.LatLong}
            />
            <p className="control locationPinContainer">
              <button
                type="button"
                className={classnames('button is-success is-outlined', {
                  'is-disabled': this.props.disableInput,
                })}
                title="Set driver to location via address"
                aria-label="Set driver to location via address"
                onClick={() => {
                  this.props.showCohortLocationModal();
                }}
              >
                <span className="icon is-small" aria-hidden="true">
                  <i className="fa fa-map-marker" />
                </span>
              </button>
            </p>
          </div>
        </div>
      );
    }
    return (
      <div className="field columns" />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/components/LatLongParamContainer.js
 **/